'use strict';

document.addEventListener('DOMContentLoaded', function () {
  const toggleButton = document.querySelector('.past-news-archive__news-button');
  if (!toggleButton) {
    return;
  }
  const newsList = document.querySelector('.past-news-archive__news-list');
  const iconRight = toggleButton.querySelector('.past-news-archive__icon');

  toggleButton.addEventListener('click', function () {
    const isOpen = newsList.classList.toggle('past-news-archive__news-list--open');

    iconRight.classList.toggle('past-news-archive__icon--close', isOpen);
    toggleButton.setAttribute('aria-expanded', isOpen);
    newsList.setAttribute('aria-hidden', !isOpen);
  });
});
